import React, {useState} from "react";
import {Navigation} from "@/components/Navigation";
import {Footer} from "@/components/Footer";
import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
import {useForm} from "react-hook-form";
import {Link, useNavigate} from "react-router-dom";
import {toast} from "sonner";
import supabase from "../utils/supabaseClient.ts";
import {SEO} from "@/components/SEO.tsx";

interface ForgotPasswordFormValues {
    email: string;
}

const ForgotPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    // const [session, setSession] = useState<Session | null>(null);

    // const navigate = useNavigate();

    const form = useForm<ForgotPasswordFormValues>({
        defaultValues: {
            email: "",
        },
    });

    const onSubmit = async (loginFormValues: ForgotPasswordFormValues) => {
        setIsLoading(true);
        if (!loginFormValues.email) {
            return toast.error('Please check your email.');
        }

        try {
            const { error} = await supabase.auth.resetPasswordForEmail(
                loginFormValues.email,
                {
                    redirectTo: 'http://localhost:8080/recover',
                }
            );

            // Hata kontrolü
            if (error) {
                setIsLoading(false);
                return toast.error(error.message);
            }

            setIsSubmitted(true);


        } catch (err) {
            // console.error('error:', err);
            toast.error('An error occurred.');
        }

        setIsLoading(false);
    };

    return (
        <div className="min-h-screen bg-white font-sans dark:bg-background">
            <SEO
                title="Forgot Password"
                description="Forgot your password? No worries, easily reset it here"
                type="website"
                name="blankpoll"
                imageUrl="/blankpoll-banner.jpg"
            />
            <Navigation/>
            <div className="container max-w-md mx-auto pt-24 px-4">
                <div className="bg-white p-8 rounded-lg border border-gray-200 dark:bg-gray-800/50 dark:border-gray-700">
                    <h2 className="text-2xl font-bold text-center mb-6">Recover Password</h2>
                    {!isSubmitted ? (
                        <>
                            <Form {...form}>
                                <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
                                    <FormField
                                        control={form.control}
                                        name="email"
                                        render={({field}) => (
                                            <FormItem>
                                                <FormLabel>Email</FormLabel>
                                                <FormControl>
                                                    <Input placeholder="Enter your email" type="email" {...field}
                                                           autoComplete={"off"} className={"dark:bg-gray-700 dark:text-white dark:border-gray-600"}/>
                                                </FormControl>
                                                <FormMessage/>
                                            </FormItem>
                                        )}
                                    />
                                    <Button className="w-full text-white dark:bg-[#2C3930] dark:hover:bg-[#2C3930]/90" type="submit" disabled={isLoading}>
                                        {isLoading ? "Processing..." : "Recover"}
                                    </Button>
                                </form>
                            </Form>
                            <div className="mt-6 text-center text-sm">
                                <span className="text-gray-600 dark:text-gray-300 dark:hover:text-white">Already have an account?</span>{" "}
                                <Link to="/login" className="text-primary hover:underline">
                                    Login
                                </Link>
                            </div>
                            <div className="mt-4 text-center text-sm">
                                <span className="text-gray-600 dark:text-gray-300 dark:hover:text-white">Don't have an account?</span>{" "}
                                <Link to="/signup" className="text-primary hover:underline">
                                    Sign up
                                </Link>
                            </div>
                        </>
                    ) : (
                        <div className="text-center space-y-4">
                            <h2 className="text-2xl font-bold">Check Your Email!</h2>
                            <p className="text-secondary-light">
                                We've sent a password recovery email to your inbox. Please click the link in the email to
                                reset your password.
                            </p>
                            {/*<Button onClick={() => navigate("/login")} className="w-full">
                                Go to Login
                            </Button>*/}
                        </div>
                    )
                    }
                </div>
            </div>
            <Footer/>
        </div>
    )
        ;
};

export default ForgotPassword;
